var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturingQualityGlobalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0565 15.0381L19.824 24.9851C19.8438 25.1022 19.8273 25.2226 19.7768 25.3301C19.7264 25.4377 19.6443 25.5272 19.5415 25.5868C19.4388 25.6465 19.3203 25.6733 19.2019 25.6637C19.0835 25.6542 18.9708 25.6087 18.879 25.5334L14.7023 22.3986C14.5007 22.248 14.2557 22.1666 14.004 22.1666C13.7524 22.1666 13.5074 22.248 13.3058 22.3986L9.12212 25.5323C9.03033 25.6074 8.91779 25.6528 8.79953 25.6624C8.68127 25.6719 8.56291 25.6452 8.46023 25.5858C8.35755 25.5263 8.27544 25.437 8.22486 25.3296C8.17428 25.2223 8.15762 25.1021 8.17712 24.9851L9.94345 15.0381",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.333C17.866 16.333 21 13.199 21 9.33301C21 5.46701 17.866 2.33301 14 2.33301C10.134 2.33301 7 5.46701 7 9.33301C7 13.199 10.134 16.333 14 16.333Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturingQualityGlobalIcon);
export default __webpack_public_path__ + "static/media/manufacturingQualityGlobalIcon.108b8d1b5b5faf9568709726b1d37bfc.svg";
export { ForwardRef as ReactComponent };